import { twMerge } from "tailwind-merge";
import { ReactComponent as Checked } from "assets/morning/icon/checked.svg";
import { ReactComponent as CrossCheckOn } from "assets/morning/icon/crossCheckOn.svg";
import { ReactComponent as CrossCheckOff } from "assets/morning/icon/crossCheckOff.svg";

interface RadioOption {
    label: string;
    value: number | string;
}

interface RadioGroupProps {
    options: RadioOption[];
    selected: number | string;
    onChange: (value: number | string) => void;
    name: string;
    gap: string;
    className?: string;
    twoLine?: boolean;
    disabled?: boolean;
    containerClassName?: string;
    type?: string;
}

const Radio = ({
    options,
    selected,
    onChange,
    name,
    gap,
    className,
    twoLine = false,
    disabled,
    containerClassName,
    type = "round",
}: RadioGroupProps) => {
    const containerStyle = twMerge(`${twoLine ? "grid grid-cols-2 gap-y-4 gap-x-20" : `flex items-center ${gap}`}`, containerClassName);

    if (type === "cross") {
        return (
            <div className="flex flex-col flex-1">
                {options.map(option => (
                    <label key={option.value} className={`flex items-center ${className} cursor-pointer py-[7px]`}>
                        <span className="text-[18px] font-[500] flex-1">{option.label}</span>
                        <input
                            type="radio"
                            name={name}
                            value={option.value}
                            checked={selected === option.value}
                            onChange={() => onChange(option.value)}
                            className="sr-only"
                            disabled={disabled}
                        />
                        {selected === option.value ? <CrossCheckOn /> : <CrossCheckOff />}
                    </label>
                ))}
            </div>
        );
    }
    return (
        <div className={containerStyle}>
            {options.map(option => (
                <label key={option.value} className={`flex items-center gap-2 ${className} cursor-pointer shrink-0`}>
                    <input
                        type="radio"
                        name={name}
                        value={option.value}
                        checked={selected === option.value}
                        onChange={() => onChange(option.value)}
                        className="sr-only peer"
                        disabled={disabled}
                    />
                    {selected === option.value ? (
                        <Checked className="w-8 h-8 -mx-1.5" />
                    ) : (
                        <div className="w-5 h-5 rounded-full border-2 border-[#ccc]" />
                    )}
                    <span className="text-[18px] font-[500] peer-disabled:opacity-30 peer-disabled:cursor-not-allowed">{option.label}</span>
                </label>
            ))}
        </div>
    );
};

export default Radio;
